import { Skeleton } from 'antd';
import type { TabBarItemProps } from 'antd-mobile';
import { TabBar } from 'antd-mobile';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Link, useParams } from 'react-router-dom';

import { Icon, IconImg } from '@/v1/main/views/Icon';
import { useAuth } from '@/v1/main/views/Provider';

import styles from './Footer.module.scss';

interface MenuItem extends TabBarItemProps {
    key?: React.Key;
    label?: React.ReactNode;
    children?: MenuItem[];
}

export const MenuFooter = () => {
    const { t } = useTranslation(['title']);
    const { sys } = useParams();
    const { pageId, menus } = useAuth();
    const [openKey, setOpenKey] = useState<string>();

    const items: MenuItem[] = menus.map((menu) => {
        const route_prefix = `/${sys}/${menu.programName}/`;
        const children = menu.children?.map((submenu) => {
            const route = route_prefix + submenu.programName;
            return {
                key: submenu.id,
                label: (
                    <Link to={route}>{t(submenu.name, { ns: 'title' })}</Link>
                ),
                icon: (
                    <Icon
                        className={styles.icon}
                        value={submenu.iconName || menu.iconName}
                    />
                ),
            } as MenuItem;
        });

        return {
            key: menu.programName,
            value: <Icon className={styles.icon} value={menu.iconName} />,
            children,
        };
    });

    useEffect(() => {
        setOpenKey(pageId);
    }, [pageId]);

    if (!pageId) {
        return <></>;
    }
    return (
        <Skeleton loading={items.length == 0}>
            <TabBar
                defaultActiveKey={pageId}
                activeKey={openKey}
                onChange={setOpenKey}
            >
                {items.map((item) =>
                    item.children?.map((subitem) => (
                        <TabBar.Item
                            key={subitem.key}
                            icon={subitem.icon}
                            title={subitem.label}
                        ></TabBar.Item>
                    ))
                )}
                <TabBar.Item
                    key="setting"
                    icon={
                        <Icon
                            className={styles.icon}
                            value={IconImg.AiFillSetting}
                        />
                    }
                    title={
                        <Link to={`/${sys}/setting`}>
                            {t('page.user_management_setting', { ns: 'title' })}
                        </Link>
                    }
                ></TabBar.Item>
            </TabBar>
        </Skeleton>
    );
};
